'use client'

import { motion } from 'framer-motion'

const ClientLogos = ({ clients }) => {
  return (
    <>
      {/* Mobile marquee scroll */}
      <div className="block md:hidden overflow-hidden w-full">
        <motion.div
          className="flex gap-5 items-center  py-3"
          animate={{ x: ['0%', '-320%'] }}
          transition={{
            repeat: Infinity,
            repeatType: 'loop',
            duration: 10,
            ease: 'linear',
          }}
        >
          {[...clients, ...clients].map((client, index) => (
            <img
              key={index}
              src={client.src}
              alt={client.alt}
              className=" object-cover w-36"
            />
          ))}
        </motion.div>
      </div>

      {/* Desktop: scroll when overflowing */}
       
  <div className="hidden md:block overflow-hidden w-full">
  <motion.div
    className="flex items-center gap-[30px] lg:gap-[40px] mt-3 px-4 md:px-6 w-max"
    animate={{ x: ['0%', '-45%'] }}
    transition={{
      repeat: Infinity,
      repeatType: 'loop',
      duration: 10, // adjust speed as needed
      ease: 'linear',
    }}
  >
    {[...clients, ...clients].map((client, index) => (
      <img
        key={index}
        src={client.src}
        alt={client.alt}
        className=" object-cover pointer-events-none"
      />
    ))}
  </motion.div>
</div>


    </>
  )
}

export default ClientLogos
